import { ReactNode, useEffect, useState } from 'react'
import { AppBar, Badge, Button, CircularProgress, Toolbar, Tooltip } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import Container from '@mui/material/Container'
import Avatar from '@mui/material/Avatar'
import MenuItem from '@mui/material/MenuItem'
import colorConfigs from '../../../configs/colorConfigs'
import sizeConfigs from '../../../configs/sizeConfigs'
import UserService from '../../../services/UserService'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import MenuIcon from '@mui/icons-material/Menu';
import InputBase from '@mui/material/InputBase';
import NewsanIcons from '../Icons';
import { useNavigate } from 'react-router-dom'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import classes from './Topbar.module.css'
import { useDownloadContext } from '../../../providers/DownloadContext'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { styled, keyframes } from '@mui/system';

type Props = {
  state?: string;
  title?: string;
  subtitle?: string;
  backButton?: boolean;
  children?: ReactNode;
  showSearch?: boolean;
  onGoBack?():void;
  hasReloadIcon?: boolean;
  reloadPage?(): void;
}

const userImage = 'https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg';
const userHasImage = false;

const Topbar = ({ title, subtitle, children, backButton = false, showSearch=false, onGoBack, hasReloadIcon=false, reloadPage}: Props) => {
  const { pendingDownloads } = useDownloadContext();
  const [username, setUsername] = useState<string>(UserService.getUsername());
  const [email] = useState<string>(UserService.getEmail());
	const navigate = useNavigate();
  if(onGoBack === undefined) {
    onGoBack = ()=> navigate(-1);
  }
  const [goBack, setGoBack] = useState<boolean>(false);

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)
  const [anchorElNotif, setAnchorElNotif] = useState<null | HTMLElement>(null)

  const blinkAnimation = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
  `;

  const BlinkingToolbar = styled(Toolbar)(() => ({
    animation: `${blinkAnimation} 1.5s infinite`,
  }));

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = (setting: string) => {
    setAnchorElUser(null)
    switch (setting) {
      case 'Logout':
        UserService.doLogout()
        break
      default:
        break
    }
  }

  useEffect(()=>{
    if(goBack) {
      onGoBack!();
    }

  }, [goBack]);

  return (
    <AppBar
      position='relative'
      sx={{
        // width: `calc(100% - ${sizeConfigs.sidebar.width})`,
        width: '100%',
        maxWidth: 'unset',
        marginTop: '20px',
        height: sizeConfigs.topbar.heigth,
        boxShadow: 'unset',
        backgroundColor: colorConfigs.mainBg,
        color: colorConfigs.topbar.color,
        paddingLeft: '0px',
      }}
    >
      <Toolbar sx={
        {
          paddingLeft: '0px !important',
          paddingRight: '0px !important'          
        }
      }>
        <Container disableGutters maxWidth='xl' style={ {maxWidth: 'unset'} }>
          <Toolbar disableGutters sx={{
            justifyContent: 'space-between'
          }}>
            <Box sx={{ display: 'flex', paddingTop: '10px', paddingRight: '10px', alignItems: 'center', maxWidth: '70%'}}>
              <div className='topbar-icon-section' onClick={()=>{ if(backButton) { setGoBack(true); }}}>
                {
                backButton ?
                  <NavigateBeforeIcon fontSize='large' style={{cursor: 'pointer'}}></NavigateBeforeIcon>
                :
                  <NavigateNextIcon fontSize='large'></NavigateNextIcon>
                }
              </div>
              <div className='topbar-title-section'>
                <span className='topbar-title' style={{cursor: backButton ? 'pointer' : 'auto' }} onClick={()=>{ if(backButton) { setGoBack(true); }}}>{title}</span>
                <span className='topbar-subtitle'>{subtitle}</span>
              </div>
              {
                hasReloadIcon && reloadPage ? 
                  <i className={classes.refreshIconTitle}onClick={() => { reloadPage() }}>
                    {NewsanIcons.REFRESH_OUTLINED}
                  </i> 
                :
                null
              }
            </Box>
            <Box sx={{ width: `${showSearch ? 40 : 60}%`, minHeight: '42px', position: 'relative' }}>
              {children}
            </Box>
            <Box sx={{ width: `${showSearch ? 40 : 20}%`, textAlign: 'right', display: 'flex', justifyContent: 'flex-end'}}>
              {
                showSearch ? 
                  <Box className='search-container' 
                        component="form"
                        noValidate
                        autoComplete="off">

                      <IconButton sx={{ p: '10px' }} aria-label="menu" className='search-button'>
                        {NewsanIcons.SEARCH}
                      </IconButton>
                      <InputBase
                        sx={{ ml: 1, flex: 2, width: 'calc(100% - 100px)' }}
                        placeholder="Búscar"
                        inputProps={{ 'aria-label': 'buscar' }}
                      />
                      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <MenuIcon />
                      </IconButton>

                  </Box>
                : null
              }
                {pendingDownloads ? <BlinkingToolbar style={ {
                    paddingRight: '0px',
                    display: 'inline-block',
                  }}
                  >
                  <Tooltip title='Descargando...'>
                    <IconButton className={classes['button-newsan-red']} sx={{ p: 0 }}>
                      <FileDownloadOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </BlinkingToolbar>: null}
              {username ? (
                <Toolbar style={ {
                paddingRight: '0px',
                display: 'inline-block',
                }}    
                >
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar style={{borderRadius: '10px'}} alt={username} src='/static/images/avatar/2.jpg' />
                  </IconButton>
                </Toolbar>
              ) : (
                <></>
              )}
              <Menu
                sx={{ mt: '45px' }}
                id='menu-appbar'
                className='menu-user'
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <div className='user-info'>
                  <div className='profile-pic-container'>
                    <Avatar className='profile-pic' style={{borderRadius: '10px'}} alt={username} src={userHasImage ? userImage : '/static/images/avatar/2.jpg'} />
                  </div>
                  <div className='profile-detail-container'>
                    <span className='profile-detail-name'>{username}</span>
                    <span className='profile-detail-email'>{email}</span>
                    <span className='profile-detail-rol'>Rol:</span>

                  </div>
                </div>

                <div className='menu-user-buttons-container'>
                  {/* <Button variant="contained" className='button-newsan-grey'>{NewsanIcons.LOCK} Cambiar Contraseña</Button> */}
                  <Button variant="contained" className='button-newsan-red' onClick={() => handleCloseUserMenu('Logout')}><PowerSettingsNewIcon></PowerSettingsNewIcon> Cerrar Sesión</Button>

                </div>
                {/* {settings.map((setting) => (
                  <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                    <Typography textAlign='center'>{setting}</Typography>
                  </MenuItem>
                ))} */}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </Toolbar>
    </AppBar>
  )
}

export default Topbar
